import React from 'react';
import styled from 'styled-components';
import { Container } from '@ui';

const ValidationBadge = styled.div`
  background: ${({ type, theme }) => (type === 'error' ? theme.themeColors.error || '#ff4444' : '#ffa500')};
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  z-index: 10;
  cursor: help;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  margin-left: 8px;
`;

const ValidationPanel = styled.div`
  background: ${({ type, theme }) =>
    type === 'error' ? theme.themeColors.errorBackground || 'rgba(255, 68, 68, 0.1)' : 'rgba(255, 165, 0, 0.1)'};
  border-left: 4px solid ${({ type, theme }) => (type === 'error' ? theme.themeColors.error || '#ff4444' : '#ffa500')};
  border-radius: 4px;
  padding: 8px 12px;
  margin: 4px 0;
`;

const ValidationMessage = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ type, theme }) => (type === 'error' ? theme.themeColors.error || '#ff4444' : '#ffa500')};

  &:not(:last-child) {
    margin-bottom: 6px;
  }
`;

const ValidationIcon = styled.span`
  font-weight: bold;
  margin-right: 6px;
`;

const ValidationFieldLabel = styled.span`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 11px;
  margin-right: 4px;
  opacity: 0.8;
`;

export const NodeValidationDisplay = ({ nodeId, validations, top = 0 }) => {
  if (!validations || validations.length === 0) return null;

  const errors = validations.filter((v) => v.type === 'error');
  const warnings = validations.filter((v) => v.type === 'warning');

  return (
    <Container fullWidth top={top} bottom={8}>
      {errors.map((error, i) => (
        <ValidationPanel key={`error-${i}`} type="error">
          <ValidationMessage type="error">
            <ValidationIcon>⚠</ValidationIcon>
            {error.field && <ValidationFieldLabel>[{error.field}]</ValidationFieldLabel>}
            {error.message}
          </ValidationMessage>
        </ValidationPanel>
      ))}

      {warnings.map((warning, i) => (
        <ValidationPanel key={`warning-${i}`} type="warning">
          <ValidationMessage type="warning">
            <ValidationIcon>⚠</ValidationIcon>
            {warning.field && <ValidationFieldLabel>[{warning.field}]</ValidationFieldLabel>}
            {warning.message}
          </ValidationMessage>
        </ValidationPanel>
      ))}
    </Container>
  );
};

export const NodeValidationBadge = ({ nodeId, validations }) => {
  if (!validations || validations.length === 0) return null;

  const errors = validations.filter((v) => v.type === 'error');

  if (errors.length === 0) return null;

  const errorCount = errors.length;
  const title = `${errorCount} validation error${errorCount > 1 ? 's' : ''}`;

  return (
    <ValidationBadge type="error" title={title}>
      {errorCount}
    </ValidationBadge>
  );
};
